import {
    Routes,
    Route,
} from "react-router"

import CandidateHome from "./Pages/CandidateHome"
import BackgroundCheckForm from "./Pages/BackgroundCheckForm"

const CandidateRouter = () => {
    return (
        <Routes>
            <Route path="/" element={<CandidateHome />} />
            <Route path="/background-check-form-auth" element={<BackgroundCheckForm />} />
        </Routes>
    )
}

export default CandidateRouter
